import { useState, useContext } from "react";
import styled from "styled-components";
import Button from "./Button";
import { DataContext } from "../context/DataContext";
import { AnswersContext } from "../context/AnswersContext";
import MasterWrapper from "./MasterWrapper";
import clearStorage from "../utils/clearStorage";
import confirmLanguage from "../utils/confirmLanguage";

const Option = styled.option`
  color: ${(props) => (props.isSelected ? "#00AEEF" : "#555")};
  background-color: ${(props) =>
    props.isSelected ? "#D9EEF7" : "transparent"};
  &:after {
    content: ${(props) => (props.isSelected ? '"✓"' : '""')};
    color: #00aeef;
  }
`;

const Select = styled.select`
  option {
    color: #555;
    &::before {
      content: attr(data-before);
      color: #555;
    }
    &::after {
      content: attr(data-after);
      color: #ccc;
    }
    &:hover {
      background-color: #d9eef7;
    }
  }
  display: block;
  border: none;
  height: 33.75px;
  width: 480px;
  padding: 4px;
  margin: 0 auto;

  @media (max-width: 768px) {
    margin: 0 15px;
    width: 90%;
  }
`;

const LanguageHeading = styled.p`
  font-family: "Roboto", "Tahoma", "Helvetica", sans-serif;
  font-weight: 600;
  margin: 1em auto 1em auto;
  font-size: 13.8px;

  @media (max-width: 768px) {
    padding: 0 15px;
  }
`;

const LanguageSelect = ({
  loaderRef,
  localizedText,
  defaultLanguage,
  languageArray,
  setChosenLanguage,
}) => {
  const { setFetchError, setMessageError, setAttention, englishCode } =
    useContext(DataContext);
  const { answeredQuestions, setAnsweredQuestions, setCurrentPageAnswers } =
    useContext(AnswersContext);
  const { currentPage } = useContext(DataContext);

  const [currentChosenLanguage, setCurrentChosenLanguage] =
    useState(defaultLanguage);

  let localTranslations = localizedText?.find(
    (localText) =>
      localText.ProjectId === Number.parseInt(currentChosenLanguage)
  );

  return (
    <MasterWrapper flexDirection="column">
      <LanguageHeading>
        {localTranslations
          ? localTranslations?.MainSurveyHeader
          : "Please select the language in which you prefer to take the survey:"}
      </LanguageHeading>
      <Select
        onChange={(e) => setCurrentChosenLanguage(e.target.value)}
        value={currentChosenLanguage ? currentChosenLanguage : defaultLanguage}
      >
        {languageArray.map((language) => (
          <Option
            key={language.language}
            value={language.pid}
            isSelected={
              currentChosenLanguage
                ? language.pid === currentChosenLanguage
                : language.pid === defaultLanguage
            }
          >
            {language.language.split("|")[0]}
            <span style={{ opacity: 0.5 }}>|</span>
            {language.language.split("|")[1]}
          </Option>
        ))}
      </Select>

      <ButtonContainer>
        <Button
          callback={() => {
            loaderRef.current.continuousStart();
            let newLanguage = currentChosenLanguage
              ? currentChosenLanguage
              : defaultLanguage;

            const currentUrl = window.location.href;
            const newUrl = currentUrl.includes("?")
              ? `${currentUrl.replace(/&pid=\d+/g,'').replace(/pid=\d+/g,'')}&pid=${newLanguage}`
              : `${currentUrl.replace(/pid=\d+/g,'')}?pid=${newLanguage}`;
            window.history.pushState({}, "", newUrl);
            sessionStorage.setItem("pid", newLanguage);

            let answeredQuestionsCopy = [...answeredQuestions];

            if (!answeredQuestionsCopy[currentPage]) {
              answeredQuestionsCopy.push([]);
            }

            setCurrentPageAnswers(
              answeredQuestions[currentPage]
                ? answeredQuestions[currentPage]
                : []
            );
            setAnsweredQuestions([...answeredQuestionsCopy]);
  
            // Intel survey
            // fetch(`https://surveyapp.onrcx.net/OnRSurveyLite/api/SaveAnswers`, {
            confirmLanguage(newLanguage, setMessageError, setAttention, clearStorage, loaderRef, setFetchError, setChosenLanguage)
            
          }}
          text={localTranslations ? localTranslations?.Next : "Next"}
        />
      </ButtonContainer>
    </MasterWrapper>
  );


};

const ButtonContainer = styled.div`
  width: 347px;
  display: flex;
  margin: 0 auto;
  margin-top: 1em;

  @media (max-width: 768px) {
    width: 92%;
  }
`;

export default LanguageSelect;
